export default "__VITE_ASSET__BfWB_oXs__"